import { ComponentProps } from "react";
import styles from "./NoPoster.module.css";
import classNames from "classnames";

type DivProps = ComponentProps<"div">;

export default function SNoPoster({ className, children, ...rest }: DivProps) {
    return <div className={classNames(styles.NoPoster, className)} {...rest}>{children}</div>
}
